"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axiosWrapper_1 = __importDefault(require("./axiosWrapper"));
const axios_1 = __importDefault(require("axios"));
const autobind_decorator_1 = __importDefault(require("autobind-decorator"));
class BaseApi {
    constructor(hostType = 'default') {
        this.axios = axiosWrapper_1.default.create(hostType);
        this.Axios = axios_1.default;
        this.axiosWithHeaders = axiosWrapper_1.default.create(hostType, true);
    }
    post(url, data = {}, headers = {}, cancelExpertToken = null) {
        return this.req('post', url, data, headers, cancelExpertToken);
    }
    getFileByFullUrl(url) {
        const token = localStorage.getItem('token');
        if (!token)
            return null;
        return axios_1.default({
            method: 'get',
            url: url,
            headers: {
                'appearme-token': `${token === null || token === void 0 ? void 0 : token.replace('%20', ' ')}`
            },
            responseType: 'blob'
        });
    }
    upload(url, data = {}, auth = true) {
        const token = localStorage.getItem('token');
        if (!token && auth)
            return null;
        return axios_1.default({
            method: 'post',
            url: `${window.AppearMe.appConfigs.url}/${url}`,
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data',
                'appearme-token': auth ? `${token === null || token === void 0 ? void 0 : token.replace('%20', ' ')}` : ''
            },
            responseType: 'json'
        });
    }
    download(url, auth = true) {
        return axios_1.default({
            method: 'get',
            url,
            headers: {
                "Content-Type": "application/octet-stream",
                "Access-Control-Allow-Origin": "*"
            },
            responseType: "blob"
        });
    }
    delete(url, data = {}, withHeaders = false) {
        return this.req('delete', url, data, withHeaders);
    }
    put(url, data = {}, withHeaders = false) {
        return this.req('put', url, data, withHeaders || {});
    }
    get(url, data = {}, withHeaders = false) {
        return this.req('get', url, data, withHeaders || {});
    }
    async req(method, url, data = {}, headers = {}, cancelExpertToken) {
        if (!method)
            throw new Error('Method is required');
        if (!url)
            throw new Error('URL is required');
        /*if (cancelToken) {
            Object.assign(data, {cancelToken: cancelToken.token});
        }*/
        const reqData = {};
        if (method === 'get' || method === 'delete') {
            Object.assign(reqData, { params: data });
        }
        else {
            Object.assign(reqData, Object.assign({}, data));
        }
        const resp = await this.axios[method](url, reqData, {
            headers,
            cancelToken: cancelExpertToken || null
        });
        return this.serializer(resp);
    }
    serializer(response) {
        if ((response === null || response === void 0 ? void 0 : response.status) && response.status === 'error') {
            throw response;
        }
        return response || false;
    }
}
__decorate([
    autobind_decorator_1.default
], BaseApi.prototype, "serializer", null);
exports.default = BaseApi;
